import { render, staticRenderFns } from "./LivingOptionMarkers.vue?vue&type=template&id=cb263194&scoped=true&"
import script from "./LivingOptionMarkers.vue?vue&type=script&lang=js&"
export * from "./LivingOptionMarkers.vue?vue&type=script&lang=js&"
import style0 from "./LivingOptionMarkers.vue?vue&type=style&index=0&id=cb263194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb263194",
  null
  
)

export default component.exports